'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

// Slide-from-bottom entrance for [data-animate] elements as they scroll into
// view. Shared by the marketing homepage (About.tsx) and /about. The hidden
// state (opacity-0) is applied here at runtime, never in the markup, so
// content stays visible for crawlers and when JS fails to load.
const ScrollAnimations = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
};
export default ScrollAnimations;
function _temp() {
  const elements = document.querySelectorAll("[data-animate]");
  if (elements.length === 0) {
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate-[slideFromBottom_0.75s_ease-in-out_forwards]");
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: "50px"
  });
  elements.forEach(el => {
    el.classList.add("opacity-0");
    observer.observe(el);
  });
  return () => {
    elements.forEach(el_0 => observer.unobserve(el_0));
  };
}